var $e54d1a8757bfdcd2$exports = {};
$e54d1a8757bfdcd2$exports = {
    "maximum": `\u{6700}\u{5927}\u{503C}`,
    "minimum": `\u{6700}\u{5C0F}\u{503C}`
};


export {$e54d1a8757bfdcd2$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
